import request from 'project-config/services/request/request'
import {
  IGetFileShareInfoParams,
  IGetFileShareInfo,
  IGetListFilesByShareLinksParams,
  IShareFile,
  IGetListFilesByShareLinksResponse,
} from './type'

export const OutputAPI = Object.freeze({
  getFileShareInfo: (params: IGetFileShareInfoParams) => {
    return request.post<IGetFileShareInfo>('/api/rendering/task/common/getFileShareInfo', params)
  },
  getListFilesByShareLinks: (params: IGetListFilesByShareLinksParams) => {
    return request.post<IShareFile[] | IGetListFilesByShareLinksResponse>(
      '/api/rendering/task/common/listFilesByShareLinks',
      params,
    )
  },
})
